const headerNotiIcon = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M10.3636 21.75H13.6364" stroke="#595A61" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 9V6" stroke="#595A61" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.5455 9.03261C18.5455 7.23375 17.8558 5.50857 16.6283 4.23658C15.4008 2.96459 13.736 2.25 12 2.25C10.264 2.25 8.59918 2.96459 7.37166 4.23658C6.14415 5.50857 5.45455 7.23375 5.45455 9.03261V14.9674C5.45455 15.642 5.19594 16.2889 4.73563 16.7659C4.27531 17.2429 3.65099 17.5109 3 17.5109H21C20.349 17.5109 19.7247 17.2429 19.2644 16.7659C18.8041 16.2889 18.5455 15.642 18.5455 14.9674V9.03261Z" stroke="#595A61" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>

const headerSetIcon = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M9.33074 4.69231L9.9792 2.98462C10.0886 2.69548 10.281 2.44679 10.5312 2.2711C10.7815 2.09541 11.0779 2.00092 11.3817 2H12.6183C12.9221 2.00092 13.2185 2.09541 13.4688 2.2711C13.719 2.44679 13.9114 2.69548 14.0208 2.98462L14.6693 4.69231L16.871 5.98462L18.6505 5.70769C18.9468 5.66666 19.2484 5.71642 19.5169 5.85065C19.7855 5.98488 20.0088 6.19752 20.1586 6.46154L20.7618 7.53846C20.9164 7.80669 20.9876 8.11643 20.9661 8.4268C20.9445 8.73717 20.8313 9.03359 20.6412 9.27692L19.5403 10.7077V13.2923L20.6713 14.7231C20.8614 14.9664 20.9747 15.2628 20.9962 15.5732C21.0178 15.8836 20.9466 16.1933 20.792 16.4615L20.1888 17.5385C20.039 17.8025 19.8156 18.0151 19.5471 18.1493C19.2786 18.2836 18.977 18.3333 18.6807 18.2923L16.9012 18.0154L14.6994 19.3077L14.051 21.0154C13.9416 21.3045 13.7492 21.5532 13.4989 21.7289C13.2487 21.9046 12.9522 21.9991 12.6485 22H11.3817C11.0779 21.9991 10.7815 21.9046 10.5312 21.7289C10.281 21.5532 10.0886 21.3045 9.9792 21.0154L9.33074 19.3077L7.12897 18.0154L5.34946 18.2923C5.05315 18.3333 4.75158 18.2836 4.48305 18.1493C4.21453 18.0151 3.99119 17.8025 3.8414 17.5385L3.23818 16.4615C3.08361 16.1933 3.01239 15.8836 3.03393 15.5732C3.05547 15.2628 3.16875 14.9664 3.35882 14.7231L4.45971 13.2923V10.7077L3.32866 9.27692C3.13859 9.03359 3.0253 8.73717 3.00377 8.4268C2.98223 8.11643 3.05344 7.80669 3.20802 7.53846L3.81124 6.46154C3.96103 6.19752 4.18437 5.98488 4.45289 5.85065C4.72142 5.71642 5.02299 5.66666 5.3193 5.70769L7.09881 5.98462L9.33074 4.69231ZM8.98388 12C8.98388 12.6086 9.16077 13.2034 9.49219 13.7094C9.82361 14.2154 10.2947 14.6098 10.8458 14.8427C11.3969 15.0756 12.0033 15.1365 12.5884 15.0178C13.1735 14.8991 13.7109 14.606 14.1327 14.1757C14.5545 13.7454 14.8418 13.1971 14.9582 12.6003C15.0745 12.0034 15.0148 11.3847 14.7865 10.8225C14.5582 10.2603 14.1717 9.77973 13.6757 9.44163C13.1797 9.10354 12.5965 8.92308 12 8.92308C11.2001 8.92308 10.4329 9.24725 9.86728 9.82429C9.30165 10.4013 8.98388 11.1839 8.98388 12V12Z" stroke="#595A61" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>

const headerSearchIcon = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M7 12.5C10.0376 12.5 12.5 10.0376 12.5 7C12.5 3.96243 10.0376 1.5 7 1.5C3.96243 1.5 1.5 3.96243 1.5 7C1.5 10.0376 3.96243 12.5 7 12.5Z" stroke="#595A61" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.5 14.5L11 11" stroke="#595A61" strokeLinecap="round" strokeLinejoin="round" />
</svg>

const headerArrowLeft = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <path fillRule="evenodd" clipRule="evenodd" d="M9.00501 10.995L13.598 6.40199C13.6896 6.30854 13.7988 6.23416 13.9193 6.18318C14.0398 6.13219 14.1692 6.10559 14.3001 6.10493C14.4309 6.10427 14.5606 6.12956 14.6816 6.17932C14.8026 6.22909 14.9126 6.30236 15.0051 6.39488C15.0976 6.48741 15.1709 6.59736 15.2207 6.71837C15.2704 6.83939 15.2957 6.96907 15.2951 7.09992C15.2944 7.23077 15.2678 7.36019 15.2168 7.48069C15.1658 7.6012 15.0915 7.7104 14.998 7.80199L11.098 11.702L14.998 15.602C15.1806 15.7883 15.2822 16.0391 15.2809 16.2999C15.2796 16.5607 15.1754 16.8105 14.991 16.995C14.8065 17.1794 14.5568 17.2836 14.2959 17.2849C14.0351 17.2862 13.7843 17.1846 13.598 17.002L9.00501 12.41C8.81753 12.2225 8.71222 11.9682 8.71222 11.703C8.71222 11.4378 8.81753 11.1835 9.00501 10.996V10.995Z" fill="#A5ADBA" />
</svg>

const headerMoreIcon = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <circle cx="8" cy="4.9563" r="1" fill="white" />
    <circle cx="8" cy="9.4563" r="1" fill="white" />
    <circle cx="8" cy="13.4563" r="1" fill="white" />
</svg>

const emptyUsageViewIcon = <svg
    width="168"
    height="116"
    viewBox="0 0 168 116"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M160.5 19C164.366 19 167.5 22.134 167.5 26C167.5 29.866 164.366 33 160.5 33H120.5C124.366 33 127.5 36.134 127.5 40C127.5 43.866 124.366 47 120.5 47H142.5C146.366 47 149.5 50.134 149.5 54C149.5 57.866 146.366 61 142.5 61H132.326C127.452 61 123.5 64.134 123.5 68C123.5 70.5773 125.5 72.9107 129.5 75C133.366 75 136.5 78.134 136.5 82C136.5 85.866 133.366 89 129.5 89H46.5C42.634 89 39.5 85.866 39.5 82C39.5 78.134 42.634 75 46.5 75H7.5C3.63401 75 0.5 71.866 0.5 68C0.5 64.134 3.63401 61 7.5 61H47.5C51.366 61 54.5 57.866 54.5 54C54.5 50.134 51.366 47 47.5 47H22.5C18.634 47 15.5 43.866 15.5 40C15.5 36.134 18.634 33 22.5 33H62.5C58.634 33 55.5 29.866 55.5 26C55.5 22.134 58.634 19 62.5 19H160.5ZM160.5 47C164.366 47 167.5 50.134 167.5 54C167.5 57.866 164.366 61 160.5 61C156.634 61 153.5 57.866 153.5 54C153.5 50.134 156.634 47 160.5 47Z"
        fill="#F3F7FF"
    />
    <rect
        x="43.0649"
        y="15.7963"
        width="70.8704"
        height="84.4074"
        rx="7.16667"
        fill="white"
        stroke="#1F64E7"
        strokeWidth="1.59259"
    />
    <path
        d="M47.8425 93.0371V23.7593C47.8425 21.5604 49.6251 19.7778 51.824 19.7778H68.1419C70.1234 19.7778 71.7995 21.2379 72.1074 23.1953C77.1825 55.4593 86.2978 68.1901 107.424 82.9475C108.502 83.7006 109.157 84.9316 109.157 86.2467V93.0371C109.157 95.236 107.375 97.0186 105.176 97.0186H51.824C49.6251 97.0186 47.8425 95.236 47.8425 93.0371Z"
        fill="#E8F0FE"
    />
    <rect
        x="55"
        y="72.0928"
        width="4"
        height="19.9074"
        rx="1.59259"
        fill="#1F64E7"
    />
    <rect
        x="66.75"
        y="50.5928"
        width="4"
        height="41.4074"
        rx="1.59259"
        fill="#1F64E7"
    />
    <rect
        x="78.5"
        y="65.7222"
        width="4"
        height="26.2778"
        rx="1.59259"
        fill="#1F64E7"
    />
    <rect
        x="90.25"
        y="53.7778"
        width="4"
        height="38.2222"
        rx="1.59259"
        fill="#1F64E7"
    />
    <rect
        x="102"
        y="67.3149"
        width="4"
        height="24.6852"
        rx="1.59259"
        fill="#1F64E7"
    />
    <path
        d="M52.6204 28.5371H76.9074M52.6204 34.9075H85.2685M52.6204 41.2779H96.8148"
        stroke="#89B0FE"
        strokeWidth="1.59259"
        strokeLinecap="round"
    />
</svg>


const menuIcons = {
    home: <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 7.93539C15.001 7.78591 14.9709 7.63786 14.9116 7.50065C14.8523 7.36345 14.765 7.24011 14.6554 7.13846L8.00002 1L1.34464 7.13846C1.23504 7.24011 1.14779 7.36345 1.08846 7.50065C1.02913 7.63786 0.999013 7.78591 1.00002 7.93539V13.9231C1.00002 14.2087 1.11349 14.4826 1.31545 14.6846C1.51741 14.8865 1.79133 15 2.07695 15H13.9231C14.2087 15 14.4826 14.8865 14.6846 14.6846C14.8866 14.4826 15 14.2087 15 13.9231V7.93539Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 15V10.6923" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    </svg>,
    application: <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.0684 9.5C12.6206 9.5 13.0684 9.94772 13.0684 10.5L13.0684 12C13.0684 12.5523 12.6206 13 12.0684 13L2.06836 13C1.51607 13 1.06836 12.5523 1.06836 12L1.06836 10.5C1.06836 9.94771 1.51607 9.5 2.06836 9.5L12.0684 9.5Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.06836 1C7.62064 1 8.06836 1.44772 8.06836 2L8.06836 6.5C8.06836 7.05228 7.62064 7.5 7.06836 7.5L1.99997 7.5C1.44769 7.5 0.999971 7.05228 0.999971 6.5L0.999971 2C0.99997 1.44771 1.44769 1 1.99997 1L7.06836 1Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.5371 1C12.8133 1 13.0371 1.22386 13.0371 1.5L13.0371 2.75C13.0371 3.02614 12.8133 3.25 12.5371 3.25L10.5684 3.25C10.2922 3.25 10.0684 3.02614 10.0684 2.75L10.0684 1.5C10.0684 1.22386 10.2922 1 10.5684 1L12.5371 1Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.5371 5.25C12.8133 5.25 13.0371 5.47386 13.0371 5.75L13.0371 7C13.0371 7.27614 12.8133 7.5 12.5371 7.5L10.5684 7.5C10.2922 7.5 10.0684 7.27614 10.0684 7L10.0684 5.75C10.0684 5.47386 10.2922 5.25 10.5684 5.25L12.5371 5.25Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    </svg>,
    usage: <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 1.5V8L12.6 12.6" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    </svg>,
    apiDocs: <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.36365 5.05371C6.36365 4.75704 6.45962 4.46703 6.63942 4.22036C6.81923 3.97368 7.0748 3.78142 7.3738 3.66789C7.67281 3.55436 8.00183 3.52466 8.31925 3.58253C8.63667 3.64041 8.92825 3.78327 9.15709 3.99305C9.38594 4.20283 9.54179 4.4701 9.60493 4.76108C9.66807 5.05205 9.63567 5.35365 9.51181 5.62774C9.38796 5.90183 9.17822 6.13609 8.90913 6.30092C8.64003 6.46574 8.32365 6.55371 8.00001 6.55371V7.05371" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.00002 9.11621C7.8494 9.11621 7.72729 9.00428 7.72729 8.86621C7.72729 8.72814 7.8494 8.61621 8.00002 8.61621" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.99998 9.11621C8.1506 9.11621 8.27271 9.00428 8.27271 8.86621C8.27271 8.72814 8.1506 8.61621 7.99998 8.61621" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 14.5H3.63636C3.20237 14.5 2.78616 14.342 2.47928 14.0607C2.1724 13.7794 2 13.3978 2 13C2 12.6022 2.1724 12.2206 2.47928 11.9393C2.78616 11.658 3.20237 11.5 3.63636 11.5H12.9091C13.1984 11.5 13.4759 11.3946 13.6805 11.2071C13.8851 11.0196 14 10.7652 14 10.5V2.5C14 2.23478 13.8851 1.98043 13.6805 1.79289C13.4759 1.60536 13.1984 1.5 12.9091 1.5H3.63636C3.20983 1.49986 2.80009 1.65239 2.49444 1.9251C2.18878 2.19782 2.01137 2.56915 2 2.96V12.96" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.9091 11.5V14.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    </svg>,
    settings: <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.22049 2.88462L5.6528 1.68923C5.72571 1.48684 5.85398 1.31275 6.02082 1.18977C6.18765 1.06678 6.38527 1.00064 6.5878 1H7.4122C7.61473 1.00064 7.81235 1.06678 7.97918 1.18977C8.14602 1.31275 8.27429 1.48684 8.3472 1.68923L8.77951 2.88462L10.2474 3.78923L11.4337 3.59538C11.6312 3.56666 11.8323 3.6015 12.0113 3.69546C12.1903 3.78942 12.3392 3.93826 12.4391 4.12308L12.8412 4.87692C12.9443 5.06468 12.9917 5.2815 12.9774 5.49876C12.963 5.71602 12.8875 5.92351 12.7608 6.09385L12.0269 7.09538V8.90462L12.7809 9.90615C12.9076 10.0765 12.9831 10.284 12.9975 10.5012C13.0118 10.7185 12.9644 10.9353 12.8613 11.1231L12.4592 11.8769C12.3593 12.0617 12.2104 12.2106 12.0314 12.3045C11.8524 12.3985 11.6513 12.4333 11.4538 12.4046L10.2675 12.2108L8.79962 13.1154L8.36731 14.3108C8.2944 14.5132 8.16613 14.6873 7.99929 14.8102C7.83245 14.9332 7.63483 14.9994 7.43231 15H6.5878C6.38527 14.9994 6.18765 14.9332 6.02082 14.8102C5.85398 14.6873 5.72571 14.5132 5.6528 14.3108L5.22049 13.1154L3.75265 12.2108L2.56631 12.4046C2.36877 12.4333 2.16772 12.3985 1.9887 12.3045C1.80969 12.2106 1.66079 12.0617 1.56093 11.8769L1.15879 11.1231C1.05574 10.9353 1.00826 10.7185 1.02262 10.5012C1.03698 10.284 1.1125 10.0765 1.23922 9.90615L1.97314 8.90462V7.09538L1.21911 6.09385C1.09239 5.92351 1.01687 5.71602 1.00251 5.49876C0.988151 5.2815 1.03563 5.06468 1.13868 4.87692L1.54083 4.12308C1.64068 3.93826 1.78958 3.78942 1.9686 3.69546C2.14761 3.6015 2.34866 3.56666 2.5462 3.59538L3.73254 3.78923L5.22049 2.88462ZM4.98925 8C4.98925 8.42599 5.10718 8.84241 5.32813 9.19661C5.54907 9.55081 5.86311 9.82688 6.23052 9.9899C6.59794 10.1529 7.00223 10.1956 7.39228 10.1125C7.78232 10.0294 8.1406 9.82422 8.42181 9.523C8.70302 9.22178 8.89452 8.838 8.97211 8.42019C9.04969 8.00239 9.00987 7.56932 8.85769 7.17576C8.7055 6.78219 8.44777 6.44581 8.11711 6.20914C7.78644 5.97248 7.39769 5.84615 7 5.84615C6.46672 5.84615 5.95528 6.07308 5.57819 6.477C5.2011 6.88093 4.98925 7.42876 4.98925 8V8Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    </svg>,
}
const headerDropdownIcon = <svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none">
    <path d="M12.28 0.966675L7.9333 5.31334C7.41997 5.82668 6.57997 5.82668 6.06664 5.31334L1.71997 0.966675" stroke="#595A61" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
</svg>
const calenderIcon = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.07692 2.61539C1.79131 2.61539 1.51739 2.72885 1.31542 2.93081C1.11346 3.13277 1 3.40669 1 3.69231V13.9231C1 14.2087 1.11346 14.4826 1.31542 14.6846C1.51739 14.8865 1.79131 15 2.07692 15H13.9231C14.2087 15 14.4826 14.8865 14.6846 14.6846C14.8865 14.4826 15 14.2087 15 13.9231V3.69231C15 3.40669 14.8865 3.13277 14.6846 2.93081C14.4826 2.72885 14.2087 2.61539 13.9231 2.61539H11.7692" stroke="#595A61" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1 6.38461H15" stroke="#595A61" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.23047 1V4.23077" stroke="#595A61" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.7695 1V4.23077" stroke="#595A61" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.23047 2.61539H9.61508" stroke="#595A61" strokeLinecap="round" strokeLinejoin="round" />
</svg>

const ManageAppIcon = <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="16" fill="#FFB72B" fillOpacity="0.2" />
    <path d="M13.9404 21.28L18.2871 16.9333C18.8004 16.42 18.8004 15.58 18.2871 15.0666L13.9404 10.72" stroke="#3F4778" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
</svg>

const copyToClipBoardNewIcon = <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7331_34851)">
        <rect
            x="0.421053"
            y="2.94742"
            width="8.75789"
            height="12.6316"
            rx="0.421053"
            stroke="#595A62"
            strokeWidth="0.842105"
        />
        <path
            d="M3 2.61538V1.84211C3 1.37702 3.37702 1 3.84211 1H10.1579C10.623 1 11 1.37702 11 1.84211V12.1579C11 12.623 10.623 13 10.1579 13H9.54545"
            stroke="#595A62"
            strokeWidth="0.842105"
            strokeLinecap="round"
        />
    </g>
    <defs>
        <clipPath id="clip0_7331_34851">
            <rect width="12" height="16" fill="white" />
        </clipPath>
    </defs>
</svg>

const DeleteIcon = ({ className }) => {
    return (
        <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 4.20801H14" stroke="#3F4778" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M3.5 4.20801H12.5V13.208C12.5 13.4732 12.3946 13.7276 12.2071 13.9151C12.0196 14.1027 11.7652 14.208 11.5 14.208H4.5C4.23478 14.208 3.98043 14.1027 3.79289 13.9151C3.60536 13.7276 3.5 13.4732 3.5 13.208V4.20801Z" stroke="#3F4778" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5.5 4.20801V3.70801C5.5 3.04497 5.76339 2.40908 6.23223 1.94024C6.70107 1.4714 7.33696 1.20801 8 1.20801C8.66304 1.20801 9.29893 1.4714 9.76777 1.94024C10.2366 2.40908 10.5 3.04497 10.5 3.70801V4.20801" stroke="#3F4778" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M6.5 7.20898V11.2105" stroke="#3F4778" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.5 7.20898V11.2105" stroke="#3F4778" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
const EditIcon = ({ className }) => {
    return (
        <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.84006 2.40006L3.36673 8.1934C3.16006 8.4134 2.96006 8.84673 2.92006 9.14673L2.6734 11.3067C2.58673 12.0867 3.14673 12.6201 3.92006 12.4867L6.06673 12.1201C6.36673 12.0667 6.78673 11.8467 6.9934 11.6201L12.4667 5.82673C13.4134 4.82673 13.8401 3.68673 12.3667 2.2934C10.9001 0.913397 9.78673 1.40006 8.84006 2.40006Z" stroke="#595A61" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.92664 3.3667C8.2133 5.2067 9.70664 6.61337 11.56 6.80003" stroke="#595A61" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2 14.6667H14" stroke="#595A61" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

const DropdownIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.9465 5.45333H7.79316H4.05317C3.41317 5.45333 3.09317 6.22666 3.5465 6.68L6.99983 10.1333C7.55317 10.6867 8.45317 10.6867 9.0065 10.1333L10.3198 8.82L12.4598 6.68C12.9065 6.22666 12.5865 5.45333 11.9465 5.45333Z" fill="#595A62" />
        </svg>
    )
}
const CrossIcon = ({ className }) => {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3.3335 12.6668L12.6668 3.3335" stroke="#FFB72B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12.6668 12.6668L3.3335 3.3335" stroke="#FFB72B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

const CompletedTickIcon = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M8.00016 14.6667C11.6668 14.6667 14.6668 11.6667 14.6668 8C14.6668 4.33334 11.6668 1.33334 8.00016 1.33334C4.3335 1.33334 1.3335 4.33334 1.3335 8C1.3335 11.6667 4.3335 14.6667 8.00016 14.6667Z" stroke="#47A37D" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11 5.99999L7 11L5 9.49999" stroke="#47A37D" strokeLinecap="round" strokeLinejoin="round" />
</svg>

const PencilIcon = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
        d="M8.84006 2.4L3.36673 8.19334C3.16006 8.41334 2.96006 8.84667 2.92006 9.14667L2.6734 11.3067C2.58673 12.0867 3.14673 12.62 3.92006 12.4867L6.06673 12.12C6.36673 12.0667 6.78673 11.8467 6.9934 11.62L12.4667 5.82667C13.4134 4.82667 13.8401 3.68667 12.3667 2.29334C10.9001 0.913335 9.78673 1.4 8.84006 2.4Z"
        stroke="#595A61"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
    />
    <path
        d="M7.92664 3.36667C8.2133 5.20667 9.70664 6.61334 11.56 6.8"
        stroke="#595A61"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
    />
    <path
        d="M2 14.6667H14"
        stroke="#595A61"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
    />
</svg>

const TwoFactorAuthIcon = <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
        d="M5.62012 7.38L11.5001 1.5L13.5001 3.5"
        stroke="#3E497A"
        strokeLinecap="round"
        strokeLinejoin="round"
    />
    <path
        d="M9.25 3.75L11 5.5"
        stroke="#3E497A"
        strokeLinecap="round"
        strokeLinejoin="round"
    />
    <path
        d="M3.5 12.5C5.15685 12.5 6.5 11.1569 6.5 9.5C6.5 7.84315 5.15685 6.5 3.5 6.5C1.84315 6.5 0.5 7.84315 0.5 9.5C0.5 11.1569 1.84315 12.5 3.5 12.5Z"
        stroke="#3E497A"
        strokeLinecap="round"
        strokeLinejoin="round"
    />
</svg>

const verifyPhoneSmallIcon = <svg
    xmlns="http://www.w3.org/2000/svg"
    width="74"
    height="64"
    fill="none"
    viewBox="0 0 74 64"
>
    <g clipPath="url(#clip0_8078_10717)">
        <rect
            width="34.487"
            height="58.291"
            x="12.205"
            y="2.61"
            fill="#fff"
            stroke="#1B69FD"
            strokeWidth="1.22"
            rx="4.39"
        ></rect>
        <rect
            width="11.902"
            height="2.976"
            x="24.688"
            y="4.976"
            fill="#1B69FD"
            rx="1.488"
        ></rect>
        <path
            fill="#E8F0FE"
            d="M15.166 57.345V35.571c0-.704 1.305-.91 1.587-.264 3.855 8.859 12.013 15.243 23.144 21.5.538.303.327 1.133-.29 1.133H15.761a.595.595 0 01-.595-.595z"
        ></path>
        <path
            fill="#fff"
            stroke="#1B69FD"
            strokeWidth="1.22"
            d="M33.63 32.35c0-.977.792-1.77 1.77-1.77h24.995c.977 0 1.77.793 1.77 1.77v13.453c0 .27-.22.49-.49.49a.885.885 0 00-.715.363l-2.534 3.466v-2.624c0-.665-.54-1.205-1.205-1.205H35.4a1.77 1.77 0 01-1.77-1.77V32.35z"
        ></path>
        <path
            fill="#fff"
            fillRule="evenodd"
            stroke="#1F64E7"
            d="M42.68 36.04a2.023 2.023 0 110 4.047 2.023 2.023 0 010-4.047zm6.407 0a2.023 2.023 0 110 4.047 2.023 2.023 0 010-4.047zm6.407 0a2.023 2.023 0 110 4.047 2.023 2.023 0 010-4.047z"
            clipRule="evenodd"
        ></path>
        <path
            fill="#1B69FD"
            d="M46.707 12.712h.595c.329 0 .595.267.595.595v4.166a.595.595 0 01-.595.595h-.595v-5.356zM12.19 12.712h-.595a.595.595 0 00-.595.595v4.166c0 .329.267.595.595.595h.595v-5.356zM12.19 20.448h-.595a.595.595 0 00-.595.596v4.165c0 .329.267.595.595.595h.595v-5.356z"
        ></path>
    </g>
    <defs>
        <clipPath id="clip0_8078_10717">
            <path
                fill="#fff"
                d="M0 0H51.775V59.511H0z"
                transform="translate(11 2)"
            ></path>
        </clipPath>
    </defs>
</svg>

const verifyEmailSmallIcon = <svg
    xmlns="http://www.w3.org/2000/svg"
    width="76"
    height="66"
    fill="none"
    viewBox="0 0 76 66"
>
    <path
        stroke="#1F64E7"
        strokeLinecap="round"
        strokeWidth="1.222"
        d="M17.983 42.552v-7.195c0-.665.27-1.3.75-1.761L36.57 16.424a2.444 2.444 0 013.325-.06l19.247 17.224c.518.464.814 1.126.814 1.822v7.142"
    ></path>
    <path
        fill="#fff"
        stroke="#1F64E7"
        strokeWidth="1.222"
        d="M22.962 18.717c0-.743.602-1.345 1.344-1.345h22.095c.353 0 .691.139.943.386l6.505 6.4c.257.252.402.598.402.958v29.809c0 .742-.602 1.344-1.344 1.344h-28.6a1.344 1.344 0 01-1.345-1.344V18.717z"
    ></path>
    <path
        fill="#fff"
        fillRule="evenodd"
        d="M44.123 33.413a6.61 6.61 0 001.333-2.65 6.61 6.61 0 00-1.013-5.361 6.82 6.82 0 00-3.537-2.59 6.926 6.926 0 00-3.696-.129 6.793 6.793 0 00-3.089 1.678 6.656 6.656 0 00-1.275 1.664 6.57 6.57 0 00-.75 3.869c.098.868.368 1.723.811 2.509a6.81 6.81 0 003.373 2.96 6.926 6.926 0 003.229.474 6.83 6.83 0 002.642-.801"
        clipRule="evenodd"
    ></path>
    <path
        stroke="#1F64E7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.222"
        d="M44.123 33.413a6.61 6.61 0 001.333-2.65 6.61 6.61 0 00-1.013-5.361 6.82 6.82 0 00-3.537-2.59 6.926 6.926 0 00-3.696-.129 6.793 6.793 0 00-3.089 1.678 6.656 6.656 0 00-1.275 1.664 6.57 6.57 0 00-.75 3.869c.098.868.368 1.723.811 2.509a6.81 6.81 0 003.373 2.96 6.926 6.926 0 003.229.474 6.83 6.83 0 002.642-.801"
    ></path>
    <path
        fill="#E8F0FE"
        d="M44.672 29.536l-.119.001c-3.501 0-6.368-2.686-6.608-6.09-2.787.433-4.919 2.819-4.919 5.697 0 3.185 2.61 5.766 5.83 5.766 3.086 0 5.612-2.372 5.816-5.374z"
    ></path>
    <path
        fill="#fff"
        fillRule="evenodd"
        stroke="#1F64E7"
        strokeLinecap="round"
        strokeWidth="0.489"
        d="M37.253 29.594a.413.413 0 00-.588.026.424.424 0 00.027.595l1.339 1.198c.237.22.605.203.822-.038l.018-.02 2.793-3.397a.424.424 0 00-.053-.592.413.413 0 00-.586.054l-2.627 3.194-1.145-1.02z"
        clipRule="evenodd"
    ></path>
    <path
        fill="#fff"
        stroke="#1F64E7"
        strokeWidth="1.222"
        d="M59.957 62.97V39.806H17.983V62.97c0 1.055.87 1.91 1.941 1.91h38.092c1.072 0 1.941-.855 1.941-1.91z"
    ></path>
    <path
        fill="#E8F0FE"
        stroke="#E8F0FE"
        strokeLinecap="round"
        strokeWidth="1.222"
        d="M38.04 46.526L19.27 56.615a2.445 2.445 0 00-1.287 2.153V62.134l.11.867a2.282 2.282 0 002.278 1.995l38.104-.229a1.492 1.492 0 001.482-1.491V58.8c0-.89-.483-1.709-1.262-2.14L40.38 46.54a2.444 2.444 0 00-2.34-.014z"
    ></path>
    <path
        stroke="#1F64E7"
        strokeWidth="1.222"
        d="M59.957 62.97V39.806H17.983V62.97c0 1.055.87 1.91 1.941 1.91h38.092c1.072 0 1.941-.855 1.941-1.91z"
    ></path>
    <path
        stroke="#1F64E7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.222"
        d="M7.246 60.701h10.41M1 60.701h3.335m69.271.24H75m-14.557 0h10.883"
    ></path>
    <path
        stroke="#75A4FE"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.222"
        d="M50.544 3.055l-5.386 5.948M37.928 1v8.003V1zM25.262 3.055l5.386 5.948-5.386-5.948z"
    ></path>
</svg>

const BackButton = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
    <rect y="0.5" width="24" height="24" rx="12" fill="#3E497A" fill-opacity="0.05" />
    <path d="M14 17L9.40683 12.8838C8.86439 12.3977 8.86439 11.6023 9.40683 11.1162L14 7" stroke="#3F4778" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
</svg>
const AlertIcon = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M11.0596 2.91666C10.9597 2.72166 10.808 2.55801 10.621 2.44374C10.4341 2.32946 10.2192 2.269 10.0001 2.269C9.78101 2.269 9.56616 2.32946 9.37922 2.44374C9.19228 2.55801 9.0405 2.72166 8.94059 2.91666L2.39297 16.0119C2.30165 16.1931 2.25817 16.3947 2.26667 16.5974C2.27516 16.8002 2.33534 16.9974 2.4415 17.1704C2.54766 17.3433 2.69627 17.4863 2.87321 17.5856C3.05016 17.685 3.24957 17.7375 3.4525 17.7381H16.5477C16.7507 17.7375 16.9501 17.685 17.127 17.5856C17.304 17.4863 17.4526 17.3433 17.5587 17.1704C17.6649 16.9974 17.7251 16.8002 17.7336 16.5974C17.7421 16.3947 17.6986 16.1931 17.6073 16.0119L11.0596 2.91666Z"
        stroke="#FFA800" strokeLinecap="round" strokeLinejoin="round"
    />
    <path d="M10 7.61905V11.4881" stroke="#FFA800" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.0003 14.7619C9.83589 14.7619 9.70264 14.6287 9.70264 14.4643C9.70264 14.2999 9.83589 14.1667 10.0003 14.1667" stroke="#FFA800" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.0005 14.7619C10.1649 14.7619 10.2981 14.6287 10.2981 14.4643C10.2981 14.2999 10.1649 14.1667 10.0005 14.1667" stroke="#FFA800" strokeLinecap="round" strokeLinejoin="round" />
</svg>
const LockIcon = <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
        d="M12.6492 6.38461H4.24922C3.66932 6.38461 3.19922 6.86677 3.19922 7.46154V13.9231C3.19922 14.5178 3.66932 15 4.24922 15H12.6492C13.2291 15 13.6992 14.5178 13.6992 13.9231V7.46154C13.6992 6.86677 13.2291 6.38461 12.6492 6.38461Z"
        stroke="#595A61" strokeLinecap="round" strokeLinejoin="round"
    />
    <path
        d="M12.1234 6.38462V4.76923C12.1234 3.76957 11.7363 2.81085 11.0471 2.10398C10.3579 1.39711 9.42311 1 8.44844 1C7.47377 1 6.53902 1.39711 5.84982 2.10398C5.16062 2.81085 4.77344 3.76957 4.77344 4.76923V6.38462"
        stroke="#595A61" strokeLinecap="round" strokeLinejoin="round"
    />
    <path
        d="M8.44883 11.2308C8.73878 11.2308 8.97383 10.9897 8.97383 10.6923C8.97383 10.3949 8.73878 10.1538 8.44883 10.1538C8.15888 10.1538 7.92383 10.3949 7.92383 10.6923C7.92383 10.9897 8.15888 11.2308 8.44883 11.2308Z"
        stroke="#595A61" strokeLinecap="round" strokeLinejoin="round"
    />
</svg>



export {
    headerNotiIcon,
    headerSetIcon,
    headerSearchIcon,
    headerArrowLeft,
    headerMoreIcon,
    menuIcons,
    headerDropdownIcon,
    calenderIcon,
    DeleteIcon,
    EditIcon,
    DropdownIcon,
    CrossIcon,
    ManageAppIcon,
    copyToClipBoardNewIcon,
    emptyUsageViewIcon,
    CompletedTickIcon,
    PencilIcon,
    TwoFactorAuthIcon,
    verifyEmailSmallIcon,
    verifyPhoneSmallIcon,
    BackButton,
    AlertIcon,
    LockIcon
}

